import {MediaQuery} from '@constants/theme';
import {Theme} from '@emotion/react';
import {SxProps} from '@mui/material';

const linkBaseStyle = {
  flex: 1,
  px: 2,
  height: '32px',
  borderRadius: '500px',
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '16.25px',
  textAlign: 'center',
  textDecoration: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  whiteSpace: 'nowrap',
};

const styles = {
  container: {
    height: '652px',
    width: '100%',
    borderRadius: 3,
    overflow: 'hidden',
    position: 'relative',
    background: 'rgba(130, 128, 126, 1)',
    color: 'rgba(255, 255, 255, 1)',
    textDecoration:"none",
    [MediaQuery.desktop]: {
      height: '580px',
    },
    [MediaQuery.mobile]: {
      display: 'grid',
      gridTemplateRows: '1fr 1fr',
    },
  },
  bgWrapper: {
    position: 'relative',
    height: '100%',
    width: '100%',
    [MediaQuery.mobile]: {},
  },
  contentWrapper: {
    position: 'absolute',
    inset: 0,
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    px: 3,
    py: 5,
    gap: '27px',
    maxWidth: '382px',
    background: 'rgba(45, 45, 45, 0.6)',
    backdropFilter: 'blur(80px)',
    [MediaQuery.desktop]: {
      px: 3,
      py: 5,
      gap: '27px',
    },
    [MediaQuery.mobile]: {
      position: 'static',
      padding: '24px',
      gap: '12px',
      maxWidth: '100vw',
    },
  },
  contentFirstRow: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '12px',
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  name: {
    fontSize: '32px',
    fontWeight: 500,
    lineHeight: '38px',
    letterSpacing: '-0.800000011920929px',
    marginBottom: '0.5rem',
    // Clamp content to 4 lines
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 4,
    WebkitBoxOrient: 'vertical',
    [MediaQuery.mobile]: {
      fontSize: '30px',
      marginBottom: '0.25rem',
    },
  },
  caption: {
    fontSize: '17px',
    fontWeight: 500,
    lineHeight: '23.8px',
    letterSpacing: '-0.4000000059604645px',
    marginBottom: '16px',
    opacity: 0.8,
    [MediaQuery.mobile]: {
      fontSize: '14px',
      marginBottom: '12px',
    },
  },
  statusChip: {
    borderRadius: '100px',
    px: 1.5,
    height: 28,
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '16.25px',
    textAlign: 'center',
    zIndex: 1,
    width: 'fit-content',
    color: 'rgba(255, 255, 255, 1) !important',
    position: 'relative',
    overflow: 'hidden',

    [MediaQuery.mobile]: {
      position: 'absolute',
      top: '-36px',
      right: '12px',
    },

    ['&::before']: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundBlendMode: 'lighten',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      backdropFilter: 'blur(80px)',
      zIndex: 1,
    },

    ['&::after']: {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundBlendMode: 'color-dodge',
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
      backdropFilter: 'blur(80px)',
      zIndex: 2,
      [MediaQuery.mobile]: {
        backgroundColor: 'rgba(45, 45, 45, 0.6)',
        backdropFilter: 'none'
      },
    },
    ['& .MuiChip-label']: {
      zIndex: 3,
      padding: 0,
    },
  },
  apartmentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    maxWidth: '282px',
  },
  apartmentTitle: {display: 'flex', gap: '8px',flexWrap:'wrap'},
  unitTypes: {
    'borderRadius': 0,
    'padding': '4px',
    'height': 24,
    'fontSize': '12px',
    'fontWeight': 400,
    'lineHeight': '16.25px',
    'textAlign': 'center',
    'zIndex': 1,
    'width': 'fit-content',
    'color': 'rgba(255, 255, 255, 1) !important',
    'position': 'relative',
    'overflow': 'hidden',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundBlendMode: 'lighten',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      backdropFilter: 'blur(80px)',
      zIndex: 1,
    },

    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundBlendMode: 'color-dodge',
      backgroundColor: 'rgba(255, 255, 255, 0.12)',
      backdropFilter: 'blur(80px)',
      zIndex: 2,
    },
    '& .MuiChip-label': {
      zIndex: 3,
      padding: 0,
    },
  },
  apartmentDetailsList: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: 1.25,
    columnGap: 2,
    flexDirection: 'column',
  },
  apartmentDetailsSubList: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    rowGap: '8px',
  },
  apartmentDetailsItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  apartmentDetailsItemSize: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    cursor: 'pointer',
  },
  apartmentPlaceholderIcon: {
    width: '16px',
    height: '16px',
  },
  apartmentLabel: {
    fontSize: '13px',
    fontWeight: 300,
    lineHeight: '16.25px',
    maxHeight: '16px',
    [MediaQuery.mobile]: {
      maxHeight: 'none',
    },
  },
  contentDivider: {
    borderColor: 'rgba(255, 255, 255, 0.1)',
  },
  contentSecondRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  priceHelper: {
    fontSize: '13px',
    fontWeight: 300,
    lineHeight: '16.25px',
    [MediaQuery.mobile]: {
      fontSize: '12px',
    },
  },
  price: {
    fontSize: '22px',
    fontWeight: 400,
    lineHeight: '27.5px',
    letterSpacing: '-0.4px',
    [MediaQuery.mobile]: {
      fontSize: '20px',
    },
  },
  contentThirdRow: {
    display: 'flex',
    width: '100%',
    gap: 1,
    flexWrap: 'wrap',
  },
  communityDetailsLink: {
    ...linkBaseStyle,
    cursor:"pointer",
    background: 'rgba(255, 255, 255, 1)',
    color: ' rgba(45, 45, 45, 1)',
  },
  propertyListLink: {
    ...linkBaseStyle,
    color: 'rgba(255, 255, 255, 1)',
    border: '1px solid rgba(255, 255, 255, 0.75)',
  },
};

export default styles as Record<keyof typeof styles, SxProps<Theme>>;
